<template>
  <HvhModal :value="true" :title="`Select ${text}`" max-width="100%" @input="$emit('input')">
    <DataTableAsync :data="tableData" v-model="tableState" :length="(data || []).length" noSearch>
      <template #head>
        <tr>
          <Th :prop="idProp" sort>Id</Th>
          <Th prop="name" sort>Name</Th>
          <th></th>
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td>{{ item[idProp] }}</td>
          <td>{{ item.name }}</td>
          <td>
            <HvhInputSwitch :value="selectedReduced[item.id]" @input="$emit($event ? 'add' : 'remove', item)" />
          </td>
        </tr>
      </template>
    </DataTableAsync>
  </HvhModal>
</template>

<script>
import HvhModal from '../common/modal/HvhModal.vue';
import DataTableAsync from '../common/dataTable/DataTableAsync.vue';
import Th from '../common/dataTable/Th.vue';
import HvhInputSwitch from '../common/form/inputSwitch/HvhInputSwitch.vue';

export default {
  components: { HvhModal, DataTableAsync, Th, HvhInputSwitch },
  props: ['data', 'selected', 'text', 'idProp'],
  data() {
    return {
      filter: {},
      tableState: { page: 1, perPage: 50 },
    };
  },
  computed: {
    tableData() {
      var response = this.data || [];
      if (this.tableState.sortByProp) {
        var sortFnc = new Function('value', `return value.${this.tableState.sortByProp}`);
        response = response.sortBy(sortFnc);
        if (this.tableState.sortDirection === 'desc')
          response = response.reverse();
      }
      return response
        .skip(this.tableState.perPage * (this.tableState.page - 1))
        .take(this.tableState.perPage);
    },
    selectedReduced() {
      return this.selected
        .reduce((acc, f) => { acc[f.id] = true; return acc; }, {});
    },
  },
}
</script>